import { Activity } from "@ofqual/portal-activity-feed";

export enum DialogType {
  ActivityAction,
  AttachEmail
};

export interface EntityDialog {
  dialogType: DialogType;
  focusedActivity?: Activity;
};

export type EmailAttachment = {
  fileName: string;
  contentType: string;
  blobId: string;
}

export type EmailActivityBody = {
  from: string;
  to: string[];
  cc?: string[];
  bodyText?: string;
  bodyHtml?: string;
  subject: string;
  attachments: EmailAttachment[];
  originalEmailBlobId: string;
  originalFileName: string;
}